var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#349DEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 39C30.9411 39 39 30.9411 39 21C39 11.0589 30.9411 3 21 3C11.0589 3 3 11.0589 3 21C3 30.9411 11.0589 39 21 39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.42 25.98C13.57 22.75 12.02 20.27 10.97 17.22C9.92 14.17 11.27 11.68 11.99 10.83L12.5 10.23C12.89 9.75998 13.6 9.69998 14.07 10.09L18.31 13.65C18.78 14.04 18.84 14.75 18.45 15.22L17.3 16.59C16.84 17.14 16.8 17.93 17.21 18.52C19.11 21.27 21.72 23.45 24.75 24.85C25.4 25.15 26.18 24.98 26.64 24.43L27.79 23.06C28.18 22.59 28.89 22.53 29.36 22.92L33.6 26.48C34.07 26.87 34.13 27.58 33.74 28.05L33.23 28.65C32.52 29.5 30.74 31.62 27.54 31.12C23.87 30.54 21.28 29.22 17.42 25.98Z",
    fill: "#349DEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.87ee51e49ce1e8e601f7487b310dedfb.svg";
export { ForwardRef as ReactComponent };